module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("What is This Thing Called Love?")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("The Birthday")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rumor has it that Buddy Silberman drove up to Caesars Palace one afternoon with his best friend, Sonny Hurwitz, and was seen at the craps tables that evening, where Buddy was overheard making a bet with Sonny that he was either going to make forty thousand “smackers” that night or walk out of the hotel naked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was cold and raining at four in the morning when Buddy walked out of Caesars Palace, stark naked except for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("L.A. Times")]), _vm._v(" wrapped around his waist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he hurried into Sonny’s car, the night doorman heard Sonny call out, “You jerk—I wouldn’t have held you to your bet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Buddy answered, “A bet is a bet—I’m not a welcher—now get me the hell out of here.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sonny and Buddy lived and worked in Los Angeles selling wireless cable television. While they were having lunch at Junior’s delicatessen, their usual eatery, Sonny decided to take the bull by the horns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wanna ask you something seriously, Buddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shoot,” Buddy said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you ever been in love?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course! All the time,” Buddy answered. “I’d go crazy if I wasn’t in love once in a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You really mean it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure. When we were growing up, did you ever see a train standing in Milwaukee station, waiting to get started?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah . . .” Sonny answered, not having a clue where Buddy’s mind was headed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then all of a sudden you hear a big blast and the engine shoots out this gigantic gust of steam, maybe twenty, thirty feet in the air, like an explosion?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what I’m talking about, Sonny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What the hell have choo-choo trains got to do with being in love?” Sonny asked, almost choking on his corned beef sandwich.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“YOU’VE GOT TO GET RID OF THE POISONS, SONNY! You can’t let them sit inside your nuts and wait for them to explode. You gotta release all that stuff or you’ll go nuts. Didn’t you ever study mental health in high school?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sonny took a long pause before answering. Buddy’s weird meta phors always drove him crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re talking about sex, Buddy. I’m talking about love.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Same difference.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buddy . . . when you invite a young lady to your boudoir, how much time do you actually spend with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Into my WHAT?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your bedroom! Didn’t you learn any French when you were taking all those mental health classes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure! Voo lay voo voo coo shay avec moi? They understand that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who understands that?” Sonny asked, getting more and more annoyed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“French broads.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do you insult women by calling them broads?” Sonny asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because Sinatra does,” Buddy answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sonny took a deep breath and exhaled slowly. “And supposing she’s not French?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I say it anyway—makes a good impression. You wanna go to Mateo’s for dinner tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not tonight, Buddy. I’ve got a date with a very nice "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("woman")]), _vm._v(". I’ll see you tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Buddy went to dinner alone at Mateo’s, where there was a movie star eating in the booth next to him almost every time he went. When he got home he found a note under his door.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Buddy. I’m free tonight. If you want me to come over, call me.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote5"
  }, [_vm._v("xoxo Carol What’s Her Name")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Buddy had to look up her telephone number under W, for “What’s Her Name,” because he had a terrible memory when it came to last names.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carol What’s Her Name came to Buddy’s apartment at 10:30 p.m., as Buddy had requested. When she came in they greeted each other like old pals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How ya doin’?” she asked, as she gave him a nice little hug and took off her jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doing good,” Buddy answered. “You want something to drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure! What have you got?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got a half bottle of Chianti, but I opened it three days ago. It’s probably still good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have any whiskey, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry. I got whatcha callit—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crème de something—if you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no, that’s all right.” she said. “You wanna start?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They went into Buddy’s bedroom. The TV was on, of course . . . some movie in black and white, with Fred Mac-Murray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carol What’s Her Name began undressing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want me to undress you, Buddy? You like that sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, that’s all right. I’m hot to trot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ten minutes later, just when Fred MacMurray was running away from Marjorie Maine, Buddy got out of bed, gave Carol What’s Her Name fifty dollars, and said, “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anytime, Buddy,” she said as she put on her jacket. “And one day you’re gonna remember my last name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What was it again?” Buddy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Berger. BERGER! Just think of hamburgers and you can’t go wrong. Are you going to walk me to the door?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They walked through the living room and Buddy opened the door for her. She gave him a quick kiss on the cheek and left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Buddy went back to his bedroom to watch the end of the movie, which he had never turned off. When it was over, he took out the Sharp pocket telephone directory from his end table drawer, deleted “What’s Her Name,” and, under K, he wrote “Ketchup.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A week later, on Buddy’s forty-eighth birthday, Sonny treated him to the Japanese restaurant that everyone was raving about, Kamegashi Sushi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was jam-packed, but Sonny had made a big fuss on the phone a week earlier when he’d made the reservation. He said he had to have a nice table because his friend just got out of the hospital and it was his birthday and Kamegashi Sushi was his favorite restaurant in Los Angeles. He also told the lady on the phone that Buddy was a big Hollywood producer. It worked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An attractive Japanese woman—thin as a needle, with shiny black hair and wearing a very attractive black dress—greeted them at the door. Sonny recognized her voice from the telephone and figured that she must be the maître d’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, I’m Sonny Hurwitz,” he said to her. “I believe we spoke to each other on the phone last week. Thanks so much for the reservation. May I present Mr. Buddy Silberman, the Hollywood producer I told you about. He just got out of the hospital yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman introduced herself as Kayoko. She gently took Buddy’s arm and walked him past the long sushi bar. All the sushi chefs yelled “Hai!” and nodded their heads as Buddy and Sonny passed by. Kayoko led them to a semiprivate table in the corner. Buddy couldn’t figure out why they were getting special treatment. Sonny hadn’t told him about the producer business, but Buddy wasn’t complaining. He also took a fancy to this young lady, who seemed genuinely concerned about making him comfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they were seated, Kayoko said, “Would you like me to bring you lovely things to eat . . . some of our specialties . . . if you trust me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Buddy burst out with, “I trust ya, honey! Sorry—what’s your name again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Kayoko . . . Can you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course I can say ‘Kay-O-Ko!’ Hey, look at that—I can speak Japanese.” Kayoko laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right now, can you say ‘Buddy’?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bud-dy,” she said. “Oh, look—I speak English.” And they all laughed again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would the gentlemen like some hot sake?” Kayoko asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know about the gentlemen, but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we")]), _vm._v(" certainly would,” Buddy answered, and cracked up over his silly joke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kayoko made a tiny bow and left. Buddy watched her as she walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My kinda woman,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why’s that?” Sonny asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s short. She’s got a sense of humor. And she smells good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should ask her to marry you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe I will. First we gotta see how good the food is.” A waiter came to their table, holding a tray with two small jars of sake and two little cups. He placed them on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hot sake,” he said as he poured a little in their cups, then gave a polite bow and left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Happy birthday, kid,” Sonny said as he raised his cup.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“God bless you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They clicked their sake cups and took a sip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yum!” Sonny said. “This is the best sake I’ve ever had.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She sure is,” Buddy said as he turned to look for Kayoko.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few minutes later, Kayoko walked in with a tray of things that smelled sensational.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa! Whatcha got there, Kayoko?” Buddy asked, as if he was about to burst into song.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kayoko leaned over Buddy’s shoulder. While she was close to his cheek, she said softly: “Buddy, I bring you and your good friend some sashimi salad and meguro tuna hand rolls with Japanese mayo and blanched asparagus . . . and a few soft-shell crab hand rolls, warm and very special.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She artistically poured each of them a little more sake in their tiny cups. “I hope you enjoy,” she said, made a little bow, and left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oy yoi yoi! I could get used to this, Sonny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After their delicious appetizers, they had tiger shrimp in a special sauce and black cod in miso sauce. They were both stuffed, but Kayoko walked in carrying a tiny sponge cake with one lit candle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Happy birthday to you, Buddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before Buddy could blow out the candle, Sonny jumped up and said, “Wait—let me take a picture! Kayoko, you get in there, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had his little Minolta all ready. Kayoko leaned down and rested her cheek on Buddy’s cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say ‘cheese’ or ‘yummy’ or something,” Sonny said just before he took the photo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One for protection,” Buddy said before Kayoko could remove her cheek. He didn’t care about the picture; he wanted her cheek against his for a few more seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great! Got it,” Sonny said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kayoko got up and took Sonny’s camera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now you two together and I take picture.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sonny kneeled down next to Buddy and imitated Kayoko, rubbing his cheek against Buddy’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” Kayoko shouted. “Good picture. Two nice friends.” On their way out of the restaurant, Kayoko walked them to the sidewalk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Happy birthday, Buddy-san. Good life for you, always,” and she gave him a little kiss on the cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good night, Sonny-san,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kayoko bowed and went back into the restaurant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know what I like about Japanese girls?” Buddy asked as they walked to Sonny’s car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They don’t look at how short a guy is or that I got eczema on my face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think all Japanese girls do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah,” Buddy said with authority.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How many have you met?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Two, but this one’s the best.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what if you run out of Japanese girls?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I go to nice ‘fifty dollars a throw’ girls. They don’t mind, either, if I’m short and have eczema.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sonny was out of town for three weeks on business. As soon as the plane landed he called Buddy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m back! Where do you want to go for dinner tonight? WAIT! I know the answer: Kamegashi Sushi, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nah, I’m tired of Japanese food,” Buddy said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you want to see Kayoko?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nah, she’s a little bit of a drag.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’re you talking about? You wanted to marry her last week.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll tell ya later. I feel like a steak tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That night they went to the Palms restaurant. Buddy ordered a twenty-two-ounce porter house steak for two, for himself. Buddy wasn’t much of a drinker, but after a shot of Absolut with his shrimp cocktail he had a glass of Merlot with his steak and fries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me about Kayoko,” Sonny said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I went to her restaurant a couple times while you were gone. She was sweet and nice like always, and all of a sudden she wants to get married. She scared me to death. I mean, she’s a nice girl and I liked her and all . . . but, Jesus! Marriage?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you two ever—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I kissed her once, on the cheek, when I was leaving the restaurant. After that she drove me crazy with the marriage business and ‘Let’s get married,’ and ‘I take good care of you.’ I mean—Jesus, these Japanese girls.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few months later, Buddy was in Las Vegas for business, not gambling. Sonny was alone one night and felt like eating Japanese food and drinking some hot sake, but he didn’t want to run into Kayoko at Kamegashi Sushi, so he went to a new place he’d heard about, Kotobuki, in Venice. Not in Italy, of course, just near the ocean in L.A.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He walked in, and there to greet him was Kayoko. Talk about coincidence, he thought. She was polite and friendly, as always, and led him to a small table in the corner. She brought him some hot sake and poured a small cup for herself, too. They toasted each other with “Kampai.” As she was about to leave, Sonny said, “Wait! Kayoko, forgive me—would you please tell me what happened with you and Buddy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, it was very sad. I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me about it, please. I think you broke his heart, Kayoko. But maybe he broke your heart, I don’t know. I just want to find out what really happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kayoko looked at the floor for several seconds. “I like Buddy. He is a nice man. But when he wanted to get married after we met only two times—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait a minute. Are you saying "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" was the one who wanted to get married?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry—I couldn’t marry him. I don’t love Buddy. I don’t even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know")]), _vm._v(" Buddy. He came to Kamegashi Sushi almost every night and would say he wanted to marry me . . . first, like a little joke, but then serious. Very serious. And he would beg me to ‘Just give it a try, honey.’ I had to leave my job because I was so sad for him and afraid that he would keep coming to the restaurant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sonny was flabbergasted. He said a few nice things to Kayoko and told her it wasn’t her fault at all, and that Buddy was a crazy guy. He wished her a happy life. She said, “Thank you, Sonny-san.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sonny went to Buddy’s apartment a week later. He and Buddy played poker with a few friends once a week at each other’s home or apartment. It was Buddy’s turn. Sonny didn’t have the guts to talk to him about Kayoko, but he was sure that she had told him the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the middle of the poker game they all took a coffee and cake break. Sonny had to use the toilet, but one of the guys was in the guest bathroom, so he asked Buddy if it would be all right to use the one off his bedroom. Buddy said, “Sure!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Buddy’s TV was on, of course, and his bed wasn’t made up because the maid only came in once a week.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just before going into the bathroom, Sonny saw the photo he had taken of Kayoko and Buddy on his birthday. Kayoko was smiling as she leaned against Buddy’s cheek. Buddy had put the photo into a beautiful silver frame and placed it on the night table, next to his bed. Sonny had never seen him looking so happy.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a8813e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 84
// module chunks = 0